import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Connects to data-controller="organize-list"
export default class extends Controller {
  connect() {
    new Sortable(this.element, {
      animation: 150,
      handle: '.drag-handle',
      ghostClass: 'bg-gray-100',
      onEnd: (evt) => {
        this.updateElementsOrder();
      }
    });
  }

  updateElementsOrder() {
    const entityElement = this.element.querySelector('[data-entity-name]');
    const entityName = entityElement.getAttribute("data-entity-name");
    const entityItems = document.querySelectorAll(`[data-entity-name="${entityName}"]`);
    const newOrder = Array.from(entityItems).map((item, index) => {
      const entityId = item.id.split("_")[1]
      return {
        id: entityId,
        position: index + 1
      };
    });

    newOrder.forEach(item => {
      const entityElement = document.querySelector(`#${entityName}_${item.id}`);
      const positionLabel = entityElement.querySelector(`#position-label`);
      positionLabel.textContent = `Posição: ${item.position}`;
      // bannerElement.setAttribute('data-position', item.position);
    });

    const reorderEndpoint = this.element.dataset.reorderEndpoint;

    fetch(reorderEndpoint, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      body: JSON.stringify({ order: newOrder })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        this.showNotification('Ordem atualizada com sucesso!', 'success');
      } else {
        this.showNotification('Erro ao atualizar a ordem', 'error');
      }
    })
    .catch(error => {
      console.error('Erro:', error);
      showNotification('Erro ao atualizar a ordem', 'error');
    });
  }

  showNotification(message, type) {
    const notification = document.createElement('div');
    notification.className = `fixed bottom-4 right-4 p-3 rounded-md ${type === 'success' ? 'bg-green-500' : 'bg-red-500'} text-white`;
    notification.textContent = message;
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.remove();
    }, 3000);
  }
}
